export default "/static/image/lanhu/sidebar/copy.webp"